import React, { useState, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Preloader from "../components/Preloader";

//Custom Components

import Home from '../pages/home';
import HomeTwo from '../pages/home-2';
import HomeThree from '../pages/home-3';
import About from '../pages/about';
import Course from '../pages/course';
import CourseList from '../pages/course/course-list';
import CourseDetails from '../pages/course/course-details';
import CourseSidebar from '../pages/course/course-sidebar';
import Instructor from '../pages/instructor';
import InstructorDetails from '../pages/instructor/instructor-details';
import Event from '../pages/event';
import EventSidebar from '../pages/event/event-sidebar';
import EventDetails from '../pages/event/event-details';
import Login from '../pages/authentication/login';
import Signup from '../pages/authentication/signup';
import HowItWorks from '../pages/HowItWorks';
import Error from '../pages/404';
import StudentDashboard from '../pages/dashboard/student';
import InstitutionDashboard from '../pages/dashboard/institution';
import InstitutionMonitoring from '../pages/dashboard/institution-monitoring';
import StudentDeviceTest from '../pages/dashboard/student-device-test';
import StudentTestInstructions from '../pages/dashboard/student-test-instructions';
import StudentTestAttempt from '../pages/dashboard/student-test-attempt';
import QuestionManagerPage from '../pages/dashboard/question-manager';
import QuestionManagerCreatePage from '../pages/dashboard/question-manager-create';
import InstitutionTestHistoryPage from '../pages/dashboard/institution-test-history';
import AdminLayout from '../pages/admin/AdminLayout';
import LoadTop from '../components/ScrollTop/LoadTop'


const RoleDashboardRoute = ({ allowedRole, children }) => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const roleFromQuery = (params.get('role') || '').toLowerCase();
    const localRole = (localStorage.getItem('guest_user_role') || '').toLowerCase();
    const sessionRole = (sessionStorage.getItem('guest_user_role') || '').toLowerCase();
    const role = roleFromQuery || localRole || sessionRole;

    if (roleFromQuery) {
        localStorage.setItem('guest_user_role', roleFromQuery);
        sessionStorage.setItem('guest_user_role', roleFromQuery);
    }

    if (role !== allowedRole) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

const AdminAreaRoute = ({ children }) => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const roleFromQuery = (params.get('role') || '').toLowerCase();
    const localRole = (localStorage.getItem('guest_user_role') || '').toLowerCase();
    const sessionRole = (sessionStorage.getItem('guest_user_role') || '').toLowerCase();
    const role = roleFromQuery || localRole || sessionRole;
    if (roleFromQuery) {
        localStorage.setItem('guest_user_role', roleFromQuery);
        sessionStorage.setItem('guest_user_role', roleFromQuery);
    }

    if (role !== 'admin') {
        return <Navigate to="/login" replace />;
    }

    return children;
};


const App = () => {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        // Simulate data loading delay
        setTimeout(() => {
        setIsLoading(false);
        }, 500);
    }, []);

    return (
        <div className='App'>
            {isLoading ?
                <Preloader /> : ''
            }
            <>
                <LoadTop />
                <Routes>
                    <Route path="/" exact element={<Home />} />
                    <Route path="/home-2" element={<HomeTwo />} />
                    <Route path="/home-3" element={<HomeThree />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/course" exact element={<Course />} />
                    <Route path="/course-list" exact element={<CourseList />} />
                    <Route path="/course/:id" element={<CourseDetails />} />
                    <Route path="/course-sidebar" element={<CourseSidebar />} />
                    <Route path="/event" exact element={<Event />} />
                    <Route path="/event/:id" element={<EventDetails />} />
                    <Route path="/event-sidebar" element={<EventSidebar />} />
                  
          
                    <Route path="/instructor" exact element={<Instructor />} />
                    <Route path="/instructor/:id" exact element={<InstructorDetails />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/login.html" element={<Navigate to="/login" replace />} />
                    <Route path="/signup.html" element={<Navigate to="/signup" replace />} />
                    <Route path="/how-it-works" element={<HowItWorks />} />
                    <Route
                        path="/dashboard/student"
                        element={(
                            <RoleDashboardRoute allowedRole="student">
                                <StudentDashboard />
                            </RoleDashboardRoute>
                        )}
                    />
                    <Route
                        path="/dashboard/institution"
                        element={(
                            <RoleDashboardRoute allowedRole="institution">
                                <InstitutionDashboard />
                            </RoleDashboardRoute>
                        )}
                    />
                    <Route
                        path="/dashboard/institution/test-history"
                        element={(
                            <RoleDashboardRoute allowedRole="institution">
                                <InstitutionTestHistoryPage />
                            </RoleDashboardRoute>
                        )}
                    />
                    <Route
                        path="/dashboard/monitoring/:exam_id"
                        element={(
                            <RoleDashboardRoute allowedRole="institution">
                                <InstitutionMonitoring />
                            </RoleDashboardRoute>
                        )}
                    />
                    <Route
                        path="/admin/*"
                        element={(
                            <AdminAreaRoute>
                                <AdminLayout />
                            </AdminAreaRoute>
                        )}
                    />
                    <Route
                        path="/dashboard/student/device-test"
                        element={(
                            <RoleDashboardRoute allowedRole="student">
                                <StudentDeviceTest />
                            </RoleDashboardRoute>
                        )}
                    />
                    <Route
                        path="/dashboard/student/test-run"
                        element={<Navigate to="/dashboard/student/test-instructions" replace />}
                    />
                    <Route
                        path="/dashboard/student/test-instructions"
                        element={(
                            <RoleDashboardRoute allowedRole="student">
                                <StudentTestInstructions />
                            </RoleDashboardRoute>
                        )}
                    />
                    <Route
                        path="/dashboard/student/test-attempt"
                        element={(
                            <RoleDashboardRoute allowedRole="student">
                                <StudentTestAttempt />
                            </RoleDashboardRoute>
                        )}
                    />
                    <Route
                        path="/dashboard/institution/question-manager"
                        element={(
                            <RoleDashboardRoute allowedRole="question-manager">
                                <QuestionManagerPage />
                            </RoleDashboardRoute>
                        )}
                    />
                    <Route
                        path="/dashboard/institution/question-manager/create"
                        element={(
                            <RoleDashboardRoute allowedRole="question-manager">
                                <QuestionManagerCreatePage />
                            </RoleDashboardRoute>
                        )}
                    />
                    <Route path='*' element={<Error />} />
                </Routes>
            </>
        </div>
    );
}

export default App;
